

















































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import DokumentasiKelainanKulitInputModal from "@/components/modal/DokumentasiKelainanKulitInputModal.vue";
import { storeDokumentasiKelainanKulit } from "@/store/modules/DokumentasiKelainanKulitStore";
import DokumentasiKelainanKulitSvc from "@/services/DokumentasiKelainanKulit";
import { storeDokter } from "@/store/modules/dokter";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component({
  components: { CardModalTtd, DokumentasiKelainanKulitInputModal },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardDokumentasiKelainanKulit extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  modalInput = false;
  modalTtd = false;
  editData: any = null;
  signItem: any = null;
  deleting = false;

  compareDialog = false;
  compareLoading = false;
  timeline: any[] = [];

  previewDialog = false;
  previewUrl = "";

  viewLabels: Record<string, string> = {
    overview: "Overview",
    close_up: "Close-up",
    dermoscopy: "Dermoskopi",
    lainnya: "Lainnya"
  };

  mounted() {
    this.reload();
    if (!storeDokter.list.length) {
      (storeDokter as any).act_dokter_all?.();
    }
  }

  reload() {
    if (this.register) {
      storeDokumentasiKelainanKulit.getByRegister(this.register);
    }
  }

  get items() {
    return storeDokumentasiKelainanKulit.items;
  }
  get loading() {
    return storeDokumentasiKelainanKulit.loading;
  }
  get stateuser() {
    return userModule.user;
  }

  get canMake() {
    if (this.readOnly) return false;
    const profesi = (this.stateuser.profesi || "").toLowerCase();
    return ["dokter", "perawat", "bidan"].includes(profesi);
  }

  canEdit(item) {
    if (!this.canMake) return false;
    return !item.dokter || item.dokter.id == this.stateuser.id;
  }

  bisaHapus(item) {
    if (!item.signed) return this.canEdit(item);
    if (!this.canMake) return false;
    return !alasanTtdMengunciHapus(
      item.creator_user_id,
      [{ ditandatangani: item.signed, penandaTanganId: item.dokter && item.dokter.id }],
      this.stateuser.id
    );
  }

  canSignItem(item) {
    return !item.signed && item.dokter && this.stateuser.id == item.dokter.id;
  }

  labelView(v: string) {
    return this.viewLabels[v] || v || "-";
  }

  formatDate(date: string | null) {
    return date ? getHumanDateTime(date) : "-";
  }

  openInput(item: any) {
    if (this.readOnly) return;
    this.editData = item;
    this.modalInput = true;
  }

  openSign(item: any) {
    this.signItem = item;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.signItem) return;
    const resp = await DokumentasiKelainanKulitSvc.signDokter(this.signItem.id, { password });
    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay("Berhasil Tanda Tangan Dokumentasi Kelainan Kulit");
      appModule.addMsgTtd("");
      this.reload();
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  onSaved() {
    this.reload();
  }

  print(item: any) {
    DokumentasiKelainanKulitSvc.print(item.id);
  }

  async remove(item: any) {
    if (this.readOnly) return;
    if (!this.bisaHapus(item)) return;
    if (!confirm("Anda yakin akan menghapus dokumentasi ini?")) return;
    if (this.deleting) return;
    this.deleting = true;
    try {
      const resp = await DokumentasiKelainanKulitSvc.destroy(item.id);
      if (resp?.status == "1" || resp?.status == 1) {
        appModule.NoticeDelay(resp.message || "Berhasil menghapus");
        this.reload();
      }
    } finally {
      this.deleting = false;
    }
  }

  async openCompare() {
    this.compareDialog = true;
    this.compareLoading = true;
    this.timeline = [];
    try {
      const resp = await DokumentasiKelainanKulitSvc.timeline(this.rm);
      const data = resp?.data?.data;
      this.timeline = Array.isArray(data) ? data : [];
    } catch {
      this.timeline = [];
    } finally {
      this.compareLoading = false;
    }
  }

  preview(url: string) {
    this.previewUrl = url;
    this.previewDialog = true;
  }
}
